<script>
import api from '@utils/api'
import mixins from '../apimixins'
import cloneDeep from 'lodash/cloneDeep'
import TablePaginator from '@components/paginator'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'

export default {
  name: 'InvalidMeasurements',
  components: {
    AdjustColumnsDialog,
    TablePaginator,
  },
  mixins: [mixins],
  data() {
    return {
      modelName: 'InvalidMeasurement',
      isLoading: false,
      showDialog: false,
      headers: [
        { text: 'workshop', value: 'organisation', sortable: true },
        { text: 'plugGuid', value: 'plug', sortable: true },
        { text: 'oil_type', value: 'oil', sortable: true, show: true },
        { text: 'invalid_since', value: 'invalidSince', sortable: true },
        { text: 'last_valid', value: 'lastValid', sortable: true, show: true },
        { text: 'comment', value: 'comment', sortable: true, show: true },
      ],
      olderThanDays: 0,
      millisInDay: 24 * 60 * 60 * 1000,
      otherParams: {
        filter_shipment_value: 'true',
        filter_shipment_comparison: 'EQ',
      },
    }
  },
  computed: {
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  mounted() {
    let settingsFromStore = this.getSettingsFromStore()
    if (settingsFromStore) {
      this.olderThanDays = settingsFromStore
    }
    this.getPaginator()
    let filters = this.getFilters()
    if (this.filtersEmpty(filters)) {
      this.getDataSet()
    }
  },
  methods: {
    setParams() {
      this.otherParams.days = this.olderThanDays
      this.resetPage()
      this.getPaginator()
      this.getDataSet()
    },
    getDataSet() {
      this.isLoading = true
      this.prepareFilterParams()
      this.otherParams.days = this.olderThanDays
      api.getReportData('invalid_measurements', this.params).then(response => {
        this.setResponseParams(response)
        this.content = response.content
        this.isLoading = false
      })
    },
    setSettingsInStore() {
      this.$store.commit('settings/SET_SETTINGS', {
        name: this.modelName,
        params: cloneDeep(this.olderThanDays),
      })
    },
    getSettingsFromStore() {
      return this.$store.state.settings.settings[this.modelName]
    },
  },
}
</script>

<template>
  <div>
    <v-container fluid>
      <v-layout row>
        <v-flex md4>
          <v-text-field
            v-model.number="olderThanDays"
            :label="$t('label__older_than')"
            :suffix="$t('label__days')"
            type="number"
          />
        </v-flex>
        <v-flex md2>
          <v-btn
            color="primary"
            @click="setParams()"
          >
            {{ $t('buttons__apply') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
            @click="changeSort(header)"
          >
            <span> {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <router-link
              v-if="userAllowedToNavigate && props.item.organisation"
              :to="{ name: 'organization', params: { orgId: props.item.organisation }} "> {{ getValue('organization', props.item.organisation) }}
            </router-link>
            <span v-if="!userAllowedToNavigate && props.item.organisation">{{ getValue('organization', props.item.organisation) }}</span>
            <span v-if="!props.item.organisation">{{ '-' }}</span>
          </td>
          <td>
            <router-link
              v-if="userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.plug, goodsGroup: 5 }} "> {{ props.item.plug }}
            </router-link>
            <span v-else>{{ props.item.plug }} </span>
          </td>
          <td v-if="!hideValues('oil')">{{ getValue('goods', props.item.oil) }}</td>
          <td>{{ dateFormat(props.item.invalidSince) }}</td>
          <td v-if="!hideValues('lastValid')">{{ dateFormat(props.item.lastValid) }}</td>
          <td v-if="!hideValues('comment')">
            <router-link
              :to="{name: 'invalidEvents', params: { id: props.item.plug, lastValidEvent: props.item.lastValidEvent }}">
              {{ props.item.comment }}
            </router-link>
          </td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)" />
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="modelName"
      @columns-updated="updateColumns"
    />
  </div>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
</style>
